(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-gift-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('cc-gift-quiz')) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var QUESTIONS = 3;

    class CcGiftQuiz extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.steps = Array.prototype.slice.call(this.querySelectorAll('[data-quiz-step]'));
        this.progress = this.querySelector('[data-quiz-progress]');
        this.bar = this.querySelector('[data-quiz-bar]');
        this.back = this.querySelector('[data-quiz-back]');
        this.reset(false);
        this.addEventListener('click', this.onClick.bind(this));
      }

      reset(focus) {
        this.answers = {};
        this.busy = false;
        this.querySelectorAll('[data-quiz-option]').forEach(function (o) {
          o.classList.remove('is-selected');
          if (o.hasAttribute('aria-pressed')) o.setAttribute('aria-pressed', 'false');
        });
        this.show(0, focus);
      }

      onClick(e) {
        var option = e.target.closest('[data-quiz-option]');
        if (option && this.contains(option)) {
          e.preventDefault();
          if (this.busy) return;
          this.choose(option);
          return;
        }
        if (e.target.closest('[data-quiz-back]')) {
          if (!this.busy && this.index > 0) this.show(this.index - 1, true);
          return;
        }
        if (e.target.closest('[data-quiz-restart]')) this.reset(true);
      }

      choose(option) {
        var kind = option.getAttribute('data-quiz-option');
        var group = option.parentElement.querySelectorAll('[data-quiz-option]');
        group.forEach(function (o) {
          o.classList.toggle('is-selected', o === option);
          if (o.hasAttribute('aria-pressed')) o.setAttribute('aria-pressed', o === option ? 'true' : 'false');
        });
        this.answers[kind] = option;
        // A beat on the selected pill before moving on, so the tap registers.
        this.busy = true;
        var self = this;
        setTimeout(function () {
          self.busy = false;
          self.show(self.index + 1, true);
        }, reduced.matches ? 0 : 260);
      }

      show(index, focus) {
        this.index = index;
        this.steps.forEach(function (step, i) { step.hidden = i !== index; });
        var done = index >= QUESTIONS;
        if (done) this.renderResult();
        this.progress.textContent = done ? 'Done' : (index + 1) + ' / ' + QUESTIONS;
        this.bar.style.width = (done ? 100 : ((index + 1) / QUESTIONS) * 100) + '%';
        this.back.hidden = index === 0 || done;
        if (focus) {
          var heading = this.steps[index].querySelector('.cc-quiz__question');
          if (heading) heading.focus({ preventScroll: true });
          // Keep the question card in view below the sticky header (its
          // scroll-margin-top clears the header).
          var card = this.querySelector('.cc-quiz__card');
          if (card && card.getBoundingClientRect().top < 80) card.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
        }
      }

      renderResult() {
        var r = this.answers.recipient;
        var st = this.answers.style;
        var b = this.answers.budget;
        var line = '';
        var phrase = st && st.getAttribute('data-phrase');
        var who = r && r.getAttribute('data-who');
        if (phrase && who) line = phrase + ' for ' + who + '.';
        else if (phrase) line = phrase + '.';
        var tip = b && b.getAttribute('data-tip');
        if (tip) line = (line ? line + ' ' : '') + tip;
        this.querySelector('[data-quiz-summary]').textContent = line;
        var cta = this.querySelector('[data-quiz-cta]');
        if (r) cta.setAttribute('href', r.getAttribute('href'));
        cta.textContent = (r && r.getAttribute('data-cta')) || this.getAttribute('data-button-label');
      }
    }

    customElements.define('cc-gift-quiz', CcGiftQuiz);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
